import webBiLogger from '@wix/web-bi-logger';
import * as eventBuilderFunc from '@wix/bi-logger-bng/v2';

const logger = webBiLogger.factory().logger();

export const biLog = (funcName, params) => {
  if (eventBuilderFunc[funcName] && typeof eventBuilderFunc[funcName] === 'function') {
    logger.report(eventBuilderFunc[funcName](params));
  } else {
    console.error(`biLogger: ${funcName} does not exists`);
  }
};

export const biLogSafe = callback => {
  if (callback && typeof callback === 'function') {
    try {
      callback(biLog, logger);
    } catch (error) {
      console.error(`Error sending BI`, error.message);
    }
  }
};
